{
  "id": "oranos",
  "pantheon": "atlanteans",
  "name": {
    "pt-BR": "Urano",
    "en": "Oranos"
  },
  "icon": "gods/oranos",
  "portrait": "gods/oranos-portrait",
  "modifiers": [
    {
      "target": "favorRate",
      "op": "mul",
      "value": 1.285,
      "scope": {
        "ids": ["oracle"]
      },
      "note": "ArchaicAgeOranos: AutoGatherFavor and AutoLOS ModifyRateCap +4 Absolute (25 -> 29). At full LOS 3.41 -> 4.38 favor/min (x1.285); no gain while the bonus LOS is below 25."
    },
    {
      "target": "favorRate",
      "op": "mul",
      "value": 1.25,
      "scope": {
        "ids": ["oracle-hero"]
      },
      "note": "Same +4 cap on the Oracle Hero (30 -> 34): 4.92 -> 6.15 favor/min at full LOS (x1.25)."
    }
  ],
  "powers": ["shockwave"],
  "minors": {
    "classical": ["prometheus", "oceanus"],
    "heroic": ["hyperion", "theia"],
    "mythic": ["hekate", "helios"]
  },
  "unlocks": ["sky-passage", "empyrian-speed"],
  "meta": {
    "source": "Game files 19.17020 (major_gods.xml, techtree.xml ArchaicAgeOranos/ClassicalAgeOranos)",
    "checkedAt": "2026-10-18",
    "confidence": "high",
    "note": "Power: Shockwave (cooldown 180). Not expressed: every unit +4 LOS (Oracles excluded: -4); human soldiers and heroes attach an Oranos revealer to units they hit; Sky Passage build limit 2, +1 per age."
  },
  "fieldMeta": {
    "modifiers": {
      "source": "Game files 19.17020 (techtree.xml ArchaicAgeOranos; proto.xml Oracle AutoGatherFavor)",
      "checkedAt": "2026-10-18",
      "confidence": "medium",
      "note": "Multipliers derived at full LOS from the file parameters (wiki formula). Previously x1.25 for both (aomr-analyzer '+25%')."
    }
  }
}
